import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  actionsTotals: null,
  actions: {
    list: [],
    pagination: {},
  },
  errors: {},
  usages: [],
  endDate: null,
  aggregates: [],
  startDate: null,
  fleetAggregates: {
    list: [],
    pagination: {},
  },
  vehiclesUsages: {},
  visibleTimeEnd: null,
  fetchingUsages: false,
  fetchingActions: false,
  visibleTimeStart: null,
  aggregatesTotals: null,
  aggregatesLoading: false,
  // loadingVehiclesUsages: false,
  fetchingVehiclesUsages: FETCH_STATE.UNSENT,
  fetchingActionsTotals: false,
  fetchingFleetAggregates: false,
  fetchingAggregatesTotals: false,
  reservationStats: {},
  fetchingReservationStats: FETCH_STATE.UNSENT,
  vehicleStats: {},
  fetchingVehicleStats: FETCH_STATE.UNSENT,
};

const dashboardReducer = createReducer(initialState)({
  [types.FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_REQUEST]: (state) => {
    return {
      ...state,
      aggregates: [],
      aggregatesLoading: true,
    };
  },
  [types.FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      aggregates: payload,
      aggregatesLoading: false,
    };
  },
  [types.FETCH_VEHICLE_GROUP_USAGE_AGGREGATES_FAILED]: (state) => {
    return {
      ...state,
      aggregatesLoading: false,
    };
  },

  [types.FETCH_VEHICLE_GROUPS_AGGREGATES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingFleetAggregates: true,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_AGGREGATES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingFleetAggregates: false,
      fleetAggregates: {
        list: payload.data || [],
        pagination: payload.pagination,
      },
    };
  },
  [types.FETCH_VEHICLE_GROUPS_AGGREGATES_FAILED]: (state) => {
    return {
      ...state,
      fetchingFleetAggregates: false,
    };
  },

  [types.CHANGE_NOC_CALENDAR_DATES]: (state, { payload }) => {
    return {
      ...state,
      endDate: payload.endDate,
      startDate: payload.startDate,
    };
  },

  [types.CHANGE_NOC_CALENDAR_VISIBLE_TIMES]: (state, { payload }) => {
    return {
      ...state,
      visibleTimeEnd: payload.visibleTimeEnd,
      visibleTimeStart: payload.visibleTimeStart,
    };
  },

  [types.FETCH_VEHICLE_USAGES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingVehiclesUsages: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_VEHICLE_USAGES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      vehiclesUsages: payload,
      fetchingVehiclesUsages: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_VEHICLE_USAGES_FAILED]: (state) => {
    return {
      ...state,
      fetchingVehiclesUsages: FETCH_STATE.ERROR,
    };
  },

  [types.FETCH_AGGREGATES_TOTALS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAggregatesTotals: true,
    };
  },
  [types.FETCH_AGGREGATES_TOTALS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      aggregatesTotals: payload,
      fetchingAggregatesTotals: false,
    };
  },
  [types.FETCH_AGGREGATES_TOTALS_FAILED]: (state) => {
    return {
      ...state,
      fetchingAggregatesTotals: false,
    };
  },

  [types.FETCH_QUALS_ACTIONS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingActions: true,
    };
  },
  [types.FETCH_QUALS_ACTIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      actions: {
        list: payload.data,
        pagination: payload.pagination,
      },
      fetchingActions: false,
    };
  },
  [types.FETCH_QUALS_ACTIONS_FAILED]: (state) => {
    return {
      ...state,
      fetchingActions: false,
    };
  },

  [types.FETCH_QUALS_ACTIONS_TOTALS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingActionsTotals: true,
    };
  },
  [types.FETCH_QUALS_ACTIONS_TOTALS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      actionsTotals: payload,
      fetchingActionsTotals: false,
    };
  },
  [types.FETCH_QUALS_ACTIONS_TOTALS_FAILED]: (state) => {
    return {
      ...state,
      fetchingActionsTotals: false,
    };
  },

  // Reservation stats actions
  [types.FETCH_RESERVATION_STATS_REQUEST]: (state) => ({
    ...state,
    fetchingReservationStats: FETCH_STATE.LOADING,
  }),
  [types.FETCH_RESERVATION_STATS_SUCCESS]: (state, { payload }) => ({
    ...state,
    fetchingReservationStats: FETCH_STATE.DONE,
    reservationStats: payload,
  }),
  [types.FETCH_RESERVATION_STATS_FAILED]: (state) => ({
    ...state,
    fetchingReservationStats: FETCH_STATE.ERROR,
  }),

  // Vehicle stats actions
  [types.FETCH_VEHICLE_STATS_REQUEST]: (state) => ({
    ...state,
    fetchingVehicleStats: FETCH_STATE.LOADING,
  }),
  [types.FETCH_VEHICLE_STATS_SUCCESS]: (state, { payload }) => ({
    ...state,
    fetchingVehicleStats: FETCH_STATE.DONE,
    vehicleStats: payload,
  }),
  [types.FETCH_VEHICLE_STATS_FAILED]: (state) => ({
    ...state,
    fetchingVehicleStats: FETCH_STATE.ERROR,
  }),
});

export default dashboardReducer;
